export enum UserTypes {
  SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS',
  RESET_USER = 'RESET_USER',
  USER_LOGGED_OUT = 'USER_LOGGED_OUT',
}
